/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileFile } from '../../models/profile-file';

export interface AddProfileFile$Params {

/**
 * ID of profile to which will be file uploaded
 */
  id: number;
      body: {

/**
 * Name of file (how should be file named for client)
 */
'title': string;

/**
 * REPORT or CERTIFICATE type of file
 */
'fileType': string;

/**
 * Only for CERTIFICATE
 */
'year'?: number;

/**
 * Content of file - base64 encoded
 */
'file': Blob;

/**
 * Type of file (application/jpg, application/png, ..)
 */
'type': string;
}
}

export function addProfileFile(http: HttpClient, rootUrl: string, params: AddProfileFile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileFile>> {
  const rb = new RequestBuilder(rootUrl, addProfileFile.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileFile>;
    })
  );
}

addProfileFile.PATH = '/rest/profile/{id}/file';
